import { render, staticRenderFns } from "./ContactProvisionsComponent.vue?vue&type=template&id=16021e28"
import script from "./ContactProvisionsComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactProvisionsComponent.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16021e28')) {
      api.createRecord('16021e28', component.options)
    } else {
      api.reload('16021e28', component.options)
    }
    module.hot.accept("./ContactProvisionsComponent.vue?vue&type=template&id=16021e28", function () {
      api.rerender('16021e28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactProvisions/ContactProvisionsComponent.vue"
export default component.exports